import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';

const { Types, Creators } = createActions(
  {
    request: ['id', 'onSuccess', 'onFailure'],
    success: [],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'DELETE_COMPANY_MEMBER_ACCESS_',
  }
);

export interface DeleteCompanyMemberAccessState {
  id: number | null;
  loading: boolean;
  errorMessage: string | null;
}

export interface DeleteCompanyMemberAccessRequestAction {
  id: number;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: DeleteCompanyMemberAccessState = {
  id: null,
  loading: false,
  errorMessage: null,
};

const request = (
  state: DeleteCompanyMemberAccessState,
  action: DeleteCompanyMemberAccessRequestAction
) =>
  update(state, {
    id: { $set: action.id },
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: DeleteCompanyMemberAccessState) =>
  update(state, {
    id: { $set: null },
    loading: { $set: false },
  });

const failure = (
  state: DeleteCompanyMemberAccessState,
  action: FailureAction
) =>
  update(state, {
    id: { $set: null },
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: DeleteCompanyMemberAccessState) =>
  update(state, {
    id: { $set: null },
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const deleteCompanyMemberAccess = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const DeleteCompanyMemberAccessTypes = Types;
export const DeleteCompanyMemberAccessActions = Creators;
